'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dValidation$0024package$0024$002dLat$002dLon$00241 from "./samples.-Validation$package$-Lat-Lon$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Validation$package$LatLon$3$() {
}
export { $c_Lsamples_Validation$package$LatLon$3$ as $c_Lsamples_Validation$package$LatLon$3$ };
$p = $c_Lsamples_Validation$package$LatLon$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Validation$package$LatLon$3$;
/** @constructor */
function $h_Lsamples_Validation$package$LatLon$3$() {
}
export { $h_Lsamples_Validation$package$LatLon$3$ as $h_Lsamples_Validation$package$LatLon$3$ };
$h_Lsamples_Validation$package$LatLon$3$.prototype = $p;
$p.b = (function() {
  return "LatLon";
});
$p.UJ = (function(x$0) {
  return new $j_samples$002e$002dValidation$0024package$0024$002dLat$002dLon$00241.$c_Lsamples_Validation$package$LatLon$1((+x$0.g(0)), (+x$0.g(1)));
});
$p.y = (function(p) {
  return this.UJ(p);
});
var $d_Lsamples_Validation$package$LatLon$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Validation$package$LatLon$3$, "samples.Validation$package$LatLon$3$", ({
  rg: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_Validation$package$LatLon$3$ as $d_Lsamples_Validation$package$LatLon$3$ };
